import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

interface LoginErrorFormEffectProps {
  /** Increments on every failed login attempt to re-trigger the error state. */
  failureCount: number
}

/**
 * Highlights the email and password fields when a login attempt fails on the
 * server (e.g. invalid credentials). The credentials pass schema validation, so
 * react-hook-form has no error to show on its own, we set it manually here.
 */
export function LoginErrorFormEffect({
  failureCount
}: LoginErrorFormEffectProps) {
  const { setError } = useFormContext()

  useEffect(() => {
    if (failureCount > 0) {
      setError('email', { type: 'server', message: ' ' })
      setError('password', { type: 'server', message: ' ' })
    }
  }, [failureCount, setError])

  return null
}
